import { useParams } from 'react-router-dom'
import { useStateValue } from 'providers'
import { ChatPanel } from './components/panel'
import { RequireUsername } from './components/require-username'
import { useLocationChat } from './use-location-chat'

// Chat for a host managing a place (`/host/places/:slug`).
export const HostChat = () => {
  const [
    {
      session: { user }
    }
  ] = useStateValue()
  const { slug } = useParams()
  const { comments, send } = useLocationChat(`/host/places/${slug}`)

  return (
    <RequireUsername user={user}>
      <ChatPanel comments={comments} currentUserId={user.id} onSend={send} />
    </RequireUsername>
  )
}
